import CredibilityStrip from "../../components/marketing/CredibilityStrip";
import Breadcrumbs from "../../components/marketing/Breadcrumbs";
import Reveal from "../../components/marketing/Reveal";
import { useSeo } from "../../components/marketing/Seo";
import { APPROACH, ENGAGEMENTS } from "../../data/marketing";

export default function AboutPage() {
  useSeo({ title: "About", description: "Learn about CLYMACO's founder-led consulting + SaaS approach across EPR, waste management and circular economy.", path: "/about" });
  return (
    <main id="main" className="bg-parchment-base pt-36" data-testid="about-page">
      <section className="mx-auto max-w-7xl px-4 pb-16 sm:px-6">
        <Breadcrumbs items={[{ label: "Home", href: "/" }, { label: "About" }]} />
        <div className="max-w-3xl">
          <div className="font-mono text-[11px] font-semibold uppercase tracking-[0.22em] text-forest-primary">About CLYMACO</div>
          <h1 className="mt-4 font-display text-5xl font-medium tracking-tight text-forest-deep sm:text-6xl">Founder-led. Practical by design.</h1>
          <p className="mt-5 text-lg leading-relaxed text-forest-deep/65">CLYMACO Sustainability Services combines specialist advisory with a proprietary client technology layer. The work is designed to move from regulatory interpretation to systems people can actually run.</p>
        </div>
      </section>
      <CredibilityStrip />
      <section className="mx-auto grid max-w-7xl gap-8 px-4 py-16 sm:px-6 lg:grid-cols-3 lg:py-24">
        <Reveal className="rounded-3xl bg-white p-7 shadow-sm">
          <h2 className="font-display text-2xl font-medium text-forest-deep">Advice with operating context</h2>
          <p className="mt-4 text-sm leading-relaxed text-forest-deep/65">Our mandates begin with the rule, the site, the material flow or the community need. We then define responsibilities, controls and evidence so the recommendation can be implemented.</p>
        </Reveal>
        <Reveal delay={0.05} className="rounded-3xl bg-white p-7 shadow-sm">
          <h2 className="font-display text-2xl font-medium text-forest-deep">Technology where it adds continuity</h2>
          <p className="mt-4 text-sm leading-relaxed text-forest-deep/65">The client workspace is not a substitute for judgement. It keeps the data, workflows, records and follow-up actions connected after the advice is given.</p>
        </Reveal>
        <Reveal delay={0.1} className="rounded-3xl bg-forest-deep p-7 text-[#FBF9F4] shadow-sm">
          <h2 className="font-display text-2xl font-medium">Networks, not inflated claims</h2>
          <p className="mt-4 text-sm leading-relaxed text-emerald-100/70">CLYMACO works through a network of industry veterans and market specialists across Gurugram, Dublin, Tbilisi, London, Paris and Abu Dhabi.</p>
        </Reveal>
      </section>
      <section className="bg-[#F4EFE6] py-16 lg:py-24">
        <div className="mx-auto max-w-7xl px-4 sm:px-6">
          <div className="max-w-3xl">
            <div className="font-mono text-[11px] font-semibold uppercase tracking-[0.22em] text-forest-primary">How we work</div>
            <h2 className="mt-3 font-display text-3xl font-medium text-forest-deep sm:text-4xl">Clear responsibilities. Practical delivery. Evidence of progress.</h2>
          </div>
          <div className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-4">
            {APPROACH.map((step) => (
              <div key={step.name} className="rounded-3xl bg-white p-6">
                <div className="font-mono text-[10px] font-semibold uppercase tracking-[0.18em] text-forest-primary">{step.phase}</div>
                <h3 className="mt-4 font-display text-2xl font-medium text-forest-deep">{step.name}</h3>
                <p className="mt-3 text-sm leading-relaxed text-forest-deep/65">{step.desc}</p>
              </div>
            ))}
          </div>
          <div className="mt-12 grid gap-5 lg:grid-cols-3">
            {ENGAGEMENTS.map((mode) => (
              <div key={mode.title} className="rounded-3xl border border-forest-deep/10 bg-white p-6">
                <div className="font-mono text-[10px] font-semibold uppercase tracking-[0.18em] text-forest-primary">{mode.tag}</div>
                <h3 className="mt-4 font-display text-xl font-medium text-forest-deep">{mode.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-forest-deep/65">{mode.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
